import React, { createContext, useContext, useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { useDispatch } from 'react-redux';
import { inboxActions } from '../_store/inbox.slice';
import { authActions, KioskDashboardActions } from '../_store';
import { getStoredValue, setStoredValue } from "../../src/_helpers/storageHelper";

const SignalRContext = createContext(null);

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);
  const dispatch = useDispatch();
  const storedloginResponse = getStoredValue("loginResponse");
  const storedLoginDetails = getStoredValue("loginDetails");
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  useEffect(() => {
    function capitalizeKeys(obj) {
      const newObj = {};
      for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
          const capitalKey = key.charAt(0).toUpperCase() + key.slice(1);
          newObj[capitalKey] = obj[key];
        }
      }
      return newObj;
    }

    const startConnection = async () => {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseUrl}/chatHub`, { withCredentials: true })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      // Register listeners BEFORE starting connection
      newConnection.on('ReceiveMessage', (user, message, type) => {
        switch (type) {
          case 'Send_Msg':
            message = {
              ...message?.msgCommunicationSentWebModel,
              MessageStatus: message?.isCOD ? "C.O.D Pending" : "",
              IsSenderMsgDelete: false,
              IsCOD: message?.isCOD,
              MessageSentDate: message?.messageSentDate,
              PublicUserID: message?.msgCommunicationSentWebModel?.userID,
              MessageID: message?.messageID,
              InmateID: message?.msgCommunicationSentWebModel?.inmatesId,
              DebitCostOfFacility: message?.msgCommunicationSentWebModel?.messageCost,
              messageBody: message?.isCOD
                ? "Once you received free credits, you can approve these messages"
                : message?.msgCommunicationSentWebModel?.messageBody
            };
            break;

          case "Rejected_Msg":
            message = { ...message?.updateCODMessage, messageSentDate: message?.messageSentDate };
            break;

          case "Approved_Msg":
            message = {
              ...message?.updateCODMessage,
              MessageBodyText: message?.updateCODMessage?.messagetxt,
              messageBody: message?.updateCODMessage?.messagetxt || message?.messagetxt,
            };
            break;

          case "Kiosk_Emoji_Status_Update":
            dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID }));
            break;
        }

        const capitalizedData = capitalizeKeys(message);
        dispatch(authActions.updateSignalRData({
          user,
          message: type === "Read_Ecard" ? message : capitalizedData,
          type
        }));

        const podCode = storedLoginDetails?.PodCode;
        const inmateID = storedloginResponse?.InmateID;

        dispatch(KioskDashboardActions.getLoadInmateMainMenu({
          inmateID,
          podCode
        }));
      });

      newConnection.onreconnected(async () => {
        console.log("Reconnected.");

        // Re-register user after reconnection (NO .start())
        if (storedloginResponse?.InmateID) {
          const sid = await newConnection.invoke(
            "RegisterUser",
            `Kiosk_${storedloginResponse.InmateID}`
          );

          const oldId = getStoredValue(`signalRId_${storedloginResponse.InmateID}`);
          if (oldId && oldId !== sid) {
            newConnection.invoke("RemoveUser", oldId.toString());
          }

          setStoredValue(`signalRId_${storedloginResponse.InmateID}`, sid);
        }
      });

      newConnection.onreconnecting(() => {
        console.log("Connection reconnecting...");
      });

      newConnection.onclose(() => {
        console.log("Connection closed.");
      });

      try {
        // Start only once
        await newConnection.start();

        // Register user ONLY after start
        if (storedloginResponse?.InmateID) {
          const sid = await newConnection.invoke(
            "RegisterUser",
            `Kiosk_${storedloginResponse.InmateID}`
          );

          setStoredValue(`signalRId_${storedloginResponse.InmateID}`, sid);
        }

        dispatch(authActions.updateconnectionData(newConnection));
        setConnection(newConnection);

      } catch (err) {
        console.error("Error starting SignalR:", err);
      }
    };

    startConnection();

    return () => {
      if (connection) {
        connection.stop().then(() => console.log("SignalR disconnected"));
      }
    };
  }, []);

  return (
    <SignalRContext.Provider value={connection}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
